import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import App from "./App";
import ArticlePage from "./components/ArticlePage";
import FlipbookPage from "./FlipbookPage";
import "./App.css";
import "./firebase"; // Initialize Firebase at app startup

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/flipbook" element={<FlipbookPage />} />
      <Route path="/article/:id" element={<ArticlePage />} />
    </Routes>
  </BrowserRouter>
);
